// extracted by mini-css-extract-plugin
module.exports = {"text":"legislation_content-module__text--3BBvp","display":"legislation_content-module__display--3d4Q0"};